import 'css-chunksrc/client/scenes/projectStrategicAxes/projectStrategicAxesTable/projectStrategicAxisCreation/tag/styles.scss';export default {
  "tag": "_tag_13i6l_1"
};